import { useEffect } from 'react';
import { TableState } from '@/services/table/tableState';
import useTableSounds from '../../hooks/useTableSounds';
import { EventSounds } from '@/services/table/tableTypes';

interface TableSoundsProps {
  tableState: TableState;
}

const TableSounds = ({ tableState }: TableSoundsProps) => {
  const {
    playFirstWarning,
    playSecondWarning,
    playDeal,
    playBoardDeal,
    playChipsGoingToPot,
    playChipsPullingToPot,
    playChipsMany,
    playChipsFalling,
    playBet,
    playFolding,
    playCall,
    playCheck,
    playWin,
    playLose,
    playTurnRiverDeal,
  } = useTableSounds();

  const tableSounds = tableState?.sound;
  const isActingPlayer = tableState?.playerSeat?.isActingPlayer;
  // TODO: Check why this is relevant for sounds, since at the end of the hand this state changes and it runs the effect twice, making chip pulling sound run twice
  const isWinner =
    typeof tableState?.playerSeat?.seat === 'number' &&
    tableState.winnersData &&
    tableState.winnersData.playerIndexes.includes(tableState.playerSeat.seat);

  useEffect(() => {
    if (!tableState || !tableState.handState) {
      return;
    }

    switch (tableSounds) {
      case EventSounds.DEAL:
        playDeal();
        break;
      case EventSounds.FLOP:
        playBoardDeal();
        playChipsFalling();
        break;
      case EventSounds.BOARD_DEAL:
        playTurnRiverDeal();
        break;
      case EventSounds.CHIPS_PUSHING:
        playChipsGoingToPot();
        break;
      case EventSounds.CHIPS_PULLING:
        playChipsPullingToPot();
        break;
      case EventSounds.RAISE:
        playChipsMany();
        break;
      case EventSounds.BET:
        playBet();
        break;
      case EventSounds.FOLD:
        playFolding();
        break;
      case EventSounds.CALL:
        playCall();
        break;
      case EventSounds.CHECK:
        playCheck();
        break;
      case EventSounds.FIRST_WARNING:
        isActingPlayer && playFirstWarning();
        break;
      case EventSounds.SECOND_WARNING:
        isActingPlayer && playSecondWarning();
        break;
    }
  }, [tableState.sound, tableSounds, isActingPlayer, isWinner]);

  return <></>;
};

export default TableSounds;
